"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _host = require("../../host");
class HostServiceGR extends _host.HostService {
  constructor() {
    super(...arguments);
    this.MODEL_NAME_PREFIX = 'h';
  }
  getMarketingId() {
    var _window$guidedSelling;
    if (typeof ((_window$guidedSelling = window.guidedSelling) === null || _window$guidedSelling === void 0 ? void 0 : _window$guidedSelling.marketingId) !== 'function') {
      return super.getMarketingId();
    }
    return window.guidedSelling.marketingId();
  }
  addToCart(_ref) {
    var _window$guidedSelling2;
    let {
      handsetProductId,
      planProductId,
      broadbandProductId
    } = _ref;
    if (typeof ((_window$guidedSelling2 = window.guidedSelling) === null || _window$guidedSelling2 === void 0 ? void 0 : _window$guidedSelling2.addtoCart) !== 'function') {
      return super.addToCart({
        handsetProductId,
        planProductId,
        broadbandProductId
      });
    }
    const modelNameRegex = new RegExp(`^${this.MODEL_NAME_PREFIX}`);
    const formattedHandsetProductId = handsetProductId.replace(modelNameRegex, '');
    return window.guidedSelling.addtoCart(formattedHandsetProductId);
  }
}
var _default = HostServiceGR;
exports.default = _default;